import { Heading } from '@apollo/orbit';
import classnames from 'classnames';
import React from 'react';
import { twMerge } from 'tailwind-merge';

interface Props {
  className?: string;
  headingClassName?: string;
  rightSide?: React.ReactNode;
  title: string;
  /**
   * Useful if you need to pass children as a ReactNode.
   * Since `title` is also used for ARIA purposes it requires an actual string
   * to be passed as a fallback; in cases where it is preferable to use a React Node
   * via `children`, you need to ALSO set the title property.
   */
  children?: React.ReactElement | React.ReactNode;
  tabs?: React.ReactNode;
  leftAdornment?: React.ReactNode;
}

export const PageTitle = ({
  className,
  headingClassName,
  title,
  children,
  rightSide,
  tabs,
  leftAdornment,
}: Props) => {
  return (
    <nav
      className={classnames(
        'flex flex-none gap-2 border-b border-primary bg-primary px-8 pt-4',
        className,
      )}
      aria-label="Page level"
    >
      {leftAdornment}
      <div className="w-0 flex-1">
        <Heading
          as="h1"
          size="3xl"
          // eslint-disable-next-line local/no-conditional-class-names
          className={twMerge('mb-3 mr-10 space-y-3', headingClassName)}
          title={title}
        >
          {children ?? title}
        </Heading>
        {tabs}
      </div>
      <div className="flex flex-wrap items-start gap-2">{rightSide}</div>
    </nav>
  );
};
